import { render, staticRenderFns } from "./SwapTokenInfo.vue?vue&type=template&id=e0b59296&scoped=true"
import script from "./SwapTokenInfo.vue?vue&type=script&lang=ts"
export * from "./SwapTokenInfo.vue?vue&type=script&lang=ts"
import style0 from "./SwapTokenInfo.vue?vue&type=style&index=0&id=e0b59296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b59296",
  null
  
)

export default component.exports